/* Copyright (c) 2021-2026, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */

export interface lcarsQueryFormat {
    serverUrl: string;
    queryContent: string;
}

export enum PlaytestState {
    login = 'LOGIN',
    home = 'HOME',
    launch = 'LAUNCH',
    settings = 'SETTINGS',
    invites = 'INVITES',
    invitationRedeemed = 'REDEEMED',
    invitationError = 'INVITEERROR',
    none = 'NONE'
}

export interface ActiveTestDataType {
    testId: string;
    gameThumbnailUrl: string;
    coordEmail: string;
    playtesterId: string;
    testName: string;
    name: string;
    status: string; // accepted/denied by user
    cmsId: string;
    gameId: string;
    starfleetToken: string;
    nativeUrl: string;
    browserUrl: string;
    playStatus: TestState;
    startTime: Date;
    startTimeStr: string;
    endTime: Date;
    endTimeStr: string;
    notes: string;
    testType: PlaytestType;
    tags: string[];
}

export enum ResultState {
    done = 'DONE',
    pending = 'PENDING',
    initiated = 'INITIATED',
    unknown = 'UNKNOWN'
}

export enum TestState {
    playnow = 'PLAYNOW',
    upcoming = 'UPCOMING',
    expired = 'EXPIRED',
    unknown = 'UNKNOWN'
}

export enum PlaytestMenu {
    playtest = 'PLAYTEST',
    manageInvite = 'INVITE',
    settings = 'SETTINGS'
}

export enum PlaytestType {
    Normal = 'normal',
    Internal = 'instant',
    Test = 'test',
    Quick = 'quick',
    Beta = 'beta',
    Unknown = 'unknown'
}

export interface TestStatsData {
    totalRuns: number;
}

export interface TestStats {
    [key: string]: TestStatsData;
}

export const PLAYTEST_NO_END_TIME = new Date('9999-09-13T00:00:00.000Z');
export const ALTERNATE_COORDINATOR_EMAIL_TAG = '#alt-coordinator-';
export const TEST_STATS_KEY = 'testStats';
